import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { Briefcase, Loader2 } from 'lucide-react';

import { getBackendUrl } from '../../services/origin';
const API = `${getBackendUrl()}/api`;

export default function AgentLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await axios.post(`${API}/auth/agent/login`, form);
      localStorage.setItem('agent_token', r.data.token);
      localStorage.setItem('agent_info', JSON.stringify(r.data.agent));
      toast.success(`Benvenuto ${r.data.agent.name}`);
      navigate('/agent');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Credenziali non valide');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#1A1A1A] via-[#2a1a15] to-[#D44E20]/20 p-4" data-testid="agent-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[#D44E20] mb-3 shadow-lg">
            <Briefcase size={28} className="text-white" />
          </div>
          <h1 className="text-3xl font-bold text-white">Portale Agenti</h1>
          <p className="text-sm text-white/60 mt-1">Lazo Commercial Network</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl p-8 shadow-2xl">
          <div className="mb-4">
            <label className="block text-xs font-semibold text-slate-600 mb-1">Email</label>
            <input type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}
              required data-testid="agent-login-email"
              className="w-full px-3 py-2.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-[#D44E20]" />
          </div>
          <div className="mb-5">
            <label className="block text-xs font-semibold text-slate-600 mb-1">Password</label>
            <input type="password" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })}
              required data-testid="agent-login-password"
              className="w-full px-3 py-2.5 border border-slate-200 rounded-lg text-sm focus:outline-none focus:border-[#D44E20]" />
          </div>
          <button type="submit" disabled={loading} data-testid="agent-login-submit"
            className="w-full py-3 bg-[#D44E20] text-white font-bold rounded-lg hover:shadow-lg transition-all disabled:opacity-50 flex items-center justify-center gap-2">
            {loading ? <Loader2 size={16} className="animate-spin" /> : 'Accedi'}
          </button>
          <p className="text-[11px] text-center text-slate-400 mt-4">
            Accesso riservato agli agenti commerciali Lazo. Se sei un brand cliente, usa il <a href="/admin/login" className="text-[#D44E20] font-semibold hover:underline">login admin</a>.
          </p>
        </form>
      </div>
    </div>
  );
}
